var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChatPnc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0022 14.0195V10.7695M11.0022 10.7695V7.51955M11.0022 10.7695H7.75219M11.0022 10.7695H14.2522M11.0022 20.5195C9.29488 20.5222 7.61705 20.0746 6.13802 19.2217C6.05072 19.1646 5.95734 19.1174 5.8596 19.0809C5.80077 19.0646 5.7396 19.0584 5.67869 19.0625C5.58255 19.0751 5.48854 19.1006 5.39919 19.1383L2.89669 19.9714H2.89452C2.36694 20.148 2.1026 20.2368 1.9271 20.174C1.85117 20.147 1.78221 20.1035 1.72523 20.0465C1.66826 19.9895 1.62472 19.9206 1.59777 19.8446C1.53602 19.6691 1.62377 19.4059 1.79927 18.8783V18.875L2.63344 16.3769L2.6356 16.3715C2.6811 16.2317 2.70494 16.1613 2.70927 16.0941C2.71349 16.0329 2.70727 15.9713 2.69085 15.9121C2.65589 15.816 2.60971 15.7244 2.55327 15.6391L2.55002 15.6337C1.47956 13.7741 1.05243 11.6134 1.33482 9.48634C1.61722 7.35932 2.59337 5.38486 4.11197 3.86901C5.63057 2.35316 7.6068 1.38059 9.73432 1.10205C11.8618 0.823506 14.0218 1.25456 15.8795 2.32838C17.7371 3.40221 19.1887 5.05883 20.0091 7.04146C20.8296 9.02409 20.9731 11.222 20.4174 13.2945C19.8617 15.367 18.6379 17.1983 16.9357 18.5045C15.2335 19.8108 13.1479 20.5191 11.0022 20.5195Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChatPnc);
export default __webpack_public_path__ + "static/media/newChatPnc.e12fa74b4b01f1f50772e519a24050d7.svg";
export { ForwardRef as ReactComponent };